var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .trash-class-a {\n                fill: none !important;\n            }\n\n            .trash-class-b {\n                fill: #fff;\n                fill-rule: evenodd;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "trash-class-a",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "trash-class-b",
    d: "M86,846H77v1.5h9Zm-12,3H89v1.5H87.5V861a3,3,0,0,1-3,3h-6a3,3,0,0,1-3-3V850.5H74Zm12,1.5H77V861a1.5,1.5,0,0,0,1.388,1.5l.112,0h6a1.5,1.5,0,0,0,1.5-1.389L86,861Zm-6.751,2.25h1.5v7.5h-1.5Zm4.5,0h-1.5v7.5h1.5Z",
    transform: "translate(-70 -843)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_trash.e2cc855012931dca73a8c298f5d1c6d3.svg";